/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {WorkflowFormComponent as ɵc} from './workflow-form/workflow-form.component';
export {WorkflowComponent as ɵb} from './workflow.component';
export {declaration as ɵa} from './workflow.module';
export {WorkflowRoutes as ɵd} from './workflow.routing';